(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["optic-souq-category-product-shelves"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const move = (button, direction) => {
      const gallery = button.closest('[data-os-shelf-gallery]');
      const track = gallery?.querySelector('[data-os-shelf-track]');
      if (!track) return;
      track.scrollBy({ left: direction * track.clientWidth, behavior: 'smooth' });
    };

    document.addEventListener('click', (event) => {
      const previous = event.target.closest?.('[data-os-shelf-previous]');
      const next = event.target.closest?.('[data-os-shelf-next]');
      if (!previous && !next) return;
      event.preventDefault();
      event.stopPropagation();
      move(previous || next, previous ? -1 : 1);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["os-item-of-day-robinson"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const move = (button, direction) => {
      const gallery = button.closest('[data-os-home-gallery]');
      const track = gallery?.querySelector('[data-os-home-track]');
      if (!track) return;
      track.scrollBy({ left: direction * track.clientWidth, behavior: 'smooth' });
    };

    document.addEventListener('click', (event) => {
      const previous = event.target.closest?.('[data-os-home-prev]');
      const next = event.target.closest?.('[data-os-home-next]');
      if (!previous && !next) return;
      event.preventDefault();
      event.stopPropagation();
      move(previous || next, previous ? -1 : 1);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
